import React from 'react'

export default function FaceFeature({ scaleX, fill, outline, verticalOffset }) {
  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`} fill="none">
      <path
        d="M31.5001 6.65784L16.6001 1.08783V1.05786L16.5601 1.07788L16.5201 1.05786V1.08783L1.62009 6.65784L1.08008 22.6879C1.08008 22.6879 3.62009 27.3079 6.42009 29.4579L5.46008 9.51788C5.46008 9.51788 10.8601 10.5379 16.5101 10.5479C16.5201 10.5479 16.5401 10.5479 16.5501 10.5479C16.5601 10.5479 16.5801 10.5479 16.5901 10.5479C22.2401 10.5379 27.6401 9.51788 27.6401 9.51788L26.6801 29.4579C29.4801 27.3079 32.0201 22.6879 32.0201 22.6879L31.5001 6.65784Z"
        fill={fill}
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path d="M3.07031 26.3979L4.06032 6.35791" stroke={outline} strokeWidth="0.5" strokeMiterlimit="10" />
      <path
        d="M10.8903 3.38794C10.8903 3.38794 8.36033 6.24791 7.59033 9.66791"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M12.7604 2.948C12.7604 2.948 11.5504 6.24797 11.1104 10.108"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M13.8602 2.61792C13.8602 2.61792 13.0902 8.33793 13.2002 10.4379"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path d="M30.0403 26.3979L29.0503 6.35791" stroke={outline} strokeWidth="0.5" strokeMiterlimit="10" />
      <path
        d="M22.2305 3.38794C22.2305 3.38794 24.7605 6.24791 25.5305 9.66791"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M20.3604 2.948C20.3604 2.948 21.5704 6.24797 22.0104 10.108"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M19.2505 2.61792C19.2505 2.61792 20.0205 8.33793 19.9105 10.4379"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
    </g>
  )
}
